let language = {
    "TAXES-ALERT-DELETE-TITLE":"删除增值税",
    "TAXES-ALERT-DELETE-OBJECT-CONTENT":"您确定要删除当前增值税的添加吗？",
    "TAXES-ALERT-DELETE-CONTENT":"你确定要删除这个增值税吗?",
    "TAXES-ALERT-DELETE-FAIL-TITLE":"增值税删除失败",
    "TAXES-ALERT-DELETE-FAIL-CONTENT":"本次增值税删除失败，请稍后再尝试删除。",
    "TAXES-ALERT-DELETE-BUSINESS-TITLE":"账户详细资料",
    "TAXES-ALERT-DELETE-BUSINESS-CONTENT":"该账户的业务信息不完整",
    "TAXES-ALERT-DELETE-FORM-TITLE":"提交增值税",
    "TAXES-ALERT-DELETE-FORM-CONTENT":"请检查您提交的增值税信息是否正确",
    "TAXES-ALERT-DELETE-CONFIRM-TITLE":"确认信息",
    "TAXES-ALERT-DELETE-CONFIRM-CONTENT":`我确认所提供的增值税 ID 号已分配给我的企业并应使用下一步将确定我的业务，​​以便进行计费和税务报告。`,
    "TAXES-ALERT-ADD-FORM-TITLE":"提交增值税",
    "TAXES-ALERT-ADD-FORM-CONTENT":"请填写您要提交的增值税信息",
    "TAXES-ALERT-ADD-FORM-FAIL-TITLE":"增值税添加失败",
    "TAXES-ALERT-ADD-FORM-FAIL-CONTENT":"本次增值税添加失败，请稍后尝试再次添加增值税",
    "TAXES-ALERT-ADD-FORM-DISABLED-TITLE":"重复的增值税国家/地区",
    "TAXES-ALERT-ADD-FORM-DISABLED-CONTENT":"该国家/地区已添加增值税，请更改其他国家/地区",
    "TAXES-MESSAGE-DELETE-SUCCESS":"删除成功!",
    "TAXES-MESSAGE-ADD-SUCCESS":"提交增值税成功!",
    "TAXES-MODAL-QUIT-TITLE":"豁免证书向导",
    "TAXES-MODAL-QUIT-CONTENT":"您确实要退出向导吗？",
};

export { language }